import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getCookie, setCookie } from "./utils/cookieUtils";

const AppRedirect: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const redirectUser = async () => {
            // If user already visited, skip redirect
            const firstVisit = getCookie("firstVisitDone");
            if (firstVisit) return;

            // Check if we already have cached country
            let countryCode = getCookie("userCountry") || "ZA"; // fallback

            // Fetch country only if not cached
            if (!getCookie("userCountry")) {
                try {
                    const res = await fetch("https://ipwho.is/");
                    console.log(res);
                    if (res.ok) {
                        const data = await res.json();
                        countryCode = data.country_code || "ZA"; // fallback
                        setCookie("userCountry", countryCode, 7); // cache for 7 days
                    }
                } catch (e) {
                    console.error("Country detection failed, using default:", e);
                }
            }

            const userIsLocal = countryCode === "ZA";
            const targetPath = userIsLocal ? "/" : "/about/international";

            // Prevent redirect loop
            if (location.pathname !== targetPath) {
                navigate(targetPath, { replace: true });
            }

            // Mark first visit
            setCookie("firstVisitDone", "true", 365);
        };

        redirectUser();
    }, [navigate, location.pathname]);

    return null;
};

export default AppRedirect;
